import { TenantEntity } from '../TenantEntity'
import { queryJobSopReceiver, saveSopEmailReceiver } from '@/api/booking/sopEmailReceiver'

export class SopEmailReceiver extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get className() {
    return 'SopEmailReceiver'
  }
  // 获取业务绑定的sop推送联系人
  static async queryJobSopReceiver(jobUuid, companyId, pushObject) {
    return queryJobSopReceiver({ jobUuid, companyId, pushObject }).then(res => res.data)
  }
  // 保存sop推送人
  static async saveSopEmailReceiver(data) {
    await saveSopEmailReceiver(data)
  }
}
